import {useEffect, useRef} from 'react';

import {DialogContent} from '@mui/material';
import {FormProvider} from 'react-hook-form';

import DentalOfficeAccordion from './components/DentalOfficeAccordion/DentalOfficeAccordion';
import PractitionerActivityAccordion from './components/PractitionerActivityAccordion/PractitionerActivityAccordion';
import SubmitButton from './components/SubmitButton/SubmitButton';
import {useMonthlyRestitutionForm} from './hooks/useMonthlyRestitutionForm/useMonthlyRestitutionForm';
import {useRestitutionAccordion} from './hooks/useRestitutionAccordion/useRestitutionAccordion';
import {EMMAI_OFFICE_AND_PRACTITIONER_ACTIVITY_FORM_STEPS} from '../../../../../const';
import useEmmai from '../../../../../hooks/providers/useEmmai';
import CustomDimmer from '../../../../dimmer/Dimmer';
import BaseModal from '../../../../modal/BaseModal';
import MonthSelector from '../../shared/RestitutionMonthSelector/RestitutionMonthSelector/RestitutionMonthSelector';
import WarningActivityDataWillBeLostOnMonthChangeModal from '../../shared/WarningActivityDataWillBeLostOnMonthChangeModal/WarningActivityDataWillBeLostOnMonthChangeModal';

const EmmaiMonthlyRestitutionModal = () => {
  const {emmaiData, monthlyRestitutionModalOpen: isOpen, setMonthlyRestitutionModalOpen: setIsOpen} = useEmmai();

  const {methods, onSubmit, submitDisabled} = useMonthlyRestitutionForm();
  const {expanded: formStepExpanded, toggle: setFormStepExpanded} = useRestitutionAccordion(methods.formState.errors);
  const formRef = useRef(null);

  const onClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const officeErrors = methods.formState.errors.officeInformation;
    if (!officeErrors || Object.keys(officeErrors).length === 0) return;

    setTimeout(() => formRef.current.scrollIntoView({behavior: 'smooth', block: 'start'}), 500);
  }, [methods.formState.errors]);

  return (
    <BaseModal
      canCloseOnBackdropClick={false}
      headerStyle={{backgroundColor: 'primary.main', titleColor: '#FFF', closeIconColor: '#FFF', titleFontSize: 20}}
      hasTitleDivider={false}
      hasCloseIcon
      onClose={onClose}
      title="Restitution mensuelle"
      open={isOpen}
      overridesPaperProps={{
        maxWidth: 670
      }}
    >
      <form onSubmit={methods.handleSubmit(onSubmit)} ref={formRef}>
        <CustomDimmer isOpen={!emmaiData.info} spinnerText="Chargement des données" />

        <FormProvider {...methods}>
          <MonthSelector />

          <DialogContent sx={{p: 1.5}}>
            <>
              <DentalOfficeAccordion
                expanded={formStepExpanded === EMMAI_OFFICE_AND_PRACTITIONER_ACTIVITY_FORM_STEPS.FIRST_STEP}
                onChange={() => setFormStepExpanded(EMMAI_OFFICE_AND_PRACTITIONER_ACTIVITY_FORM_STEPS.FIRST_STEP)}
              />

              <PractitionerActivityAccordion
                expanded={formStepExpanded === EMMAI_OFFICE_AND_PRACTITIONER_ACTIVITY_FORM_STEPS.SECOND_STEP}
                onChange={() => setFormStepExpanded(EMMAI_OFFICE_AND_PRACTITIONER_ACTIVITY_FORM_STEPS.SECOND_STEP)}
              />
            </>
          </DialogContent>

          <SubmitButton disabled={submitDisabled} />
        </FormProvider>
      </form>
      <WarningActivityDataWillBeLostOnMonthChangeModal />
    </BaseModal>
  );
};

export default EmmaiMonthlyRestitutionModal;
